module.exports = new __parcel__URL__("EURCLogo.e814427f.svg").toString();